import React from 'react';
import FieldError from './FieldError';
import { CONTACT_FORM_LINKS } from '../../../constants/links';


interface TermsCheckboxProps {
    checked: boolean;
    error: string;
    onChange: (checked: boolean) => void;
    onBlur: () => void;
}

const TermsCheckbox: React.FC<TermsCheckboxProps> = ({ checked, error, onChange, onBlur }) => (
    <div className="cf-field cf-terms-field">
        <label className="cf-terms-label">
            <input
                type="checkbox"
                className="cf-checkbox"
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                onBlur={onBlur}
                id="cf-terms"
            />
            <span>
                קראתי ואישרתי את{' '}
                <a href={CONTACT_FORM_LINKS.TERMS_OF_USE} className="cf-terms-link" target="_blank" rel="noopener noreferrer">
                    תנאי השימוש
                </a>
                {' '}באתר ואת{' '}
                <a href={CONTACT_FORM_LINKS.PRIVACY_POLICY} className="cf-terms-link" target="_blank" rel="noopener noreferrer">
                    מדיניות הפרטיות
                </a>
            </span>
        </label>
        <FieldError message={error} />
    </div>
);

export default TermsCheckbox;
